<div class="overflow-hidden">
  <div class="-translate-y-2/3">
    <img src="assets/woordkr8/sprites/ceiling.png" class="w-full object-contain" />
  </div>
</div>
